import { render, staticRenderFns } from "./status-form-confirmation.vue?vue&type=template&id=aeb64cfe&scoped=true&"
import script from "./status-form-confirmation.vue?vue&type=script&lang=js&"
export * from "./status-form-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./status-form-confirmation.vue?vue&type=style&index=0&id=aeb64cfe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb64cfe",
  null
  
)

export default component.exports